// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "0bdaa058" + "." + "fa1c0c183c20573d" + ".js";
};